module.exports = __webpack_public_path__ + "static/media/default_insurance.48004298.png";